import React from "react";
import PageShell from "../components/PageShell";
import PageHero from "../components/PageHero";
import Contact from "../components/Contact";

export default function ContactPage() {
  return (
    <PageShell>
      <PageHero
        eyebrow="◇ Contact"
        title="Tell us about it."
        accent="it."
        kicker="The product. The system. The threat. The shape of the wall you're stuck on. We read every brief and respond within 24 hours."
      />
      <Contact />
    </PageShell>
  );
}
